import type { CoachMarkConfig } from './types'

const coachMarks: CoachMarkConfig = {
  tooltip: {
    enabled: true,
    title: 'Track and save your progress',
    body: [
      { type: 'action', text: 'Sign in', action: 'signIn', gaLabel: 'sign_in' },
      ' or ',
      {
        type: 'action',
        text: 'create an account',
        action: 'createAccount',
        gaLabel: 'create_account',
      },
      ' to save your quantum journey progress.',
    ],
    icon: 'lightbulb',
    delayMs: 3000,
  },
  pageRules: {
    toastAllPages: true,
    tooltipPathPatterns: ['/codebook', '/challenges'],
  },
  staggerMs: 500,
  positioning: {
    offsetFromHeader: 16,
    offsetFromRight: 20,
    gapBetweenMarks: 16,
  },
  toast: {
    enabled: true,
    title: 'Have your say!',
    body: [
      'Enjoying PennyLane? Take the ',
      {
        type: 'link',
        text: '2026 Unitary Foundation Quantum Open Source Software Survey',
        href: 'https://www.surveymonkey.com/r/QOSSSurvey26',
        gaLabel: 'qoss_survey',
        isExternal: true,
      },
      ' now.',
    ],
    icon: 'megaphone',
    delayMs: 3000,
    // October 30, 2026 at 9:00 AM ET
    expiryDateTime: '2026-10-30T13:00:00Z',
  },
}

export default coachMarks
